import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { CabinCard } from "@/components/CabinCard";
import { Decoracao } from "@/components/Decoracao";
import { Faq } from "@/components/Faq";
import { Contato } from "@/components/Contato";
import { Footer } from "@/components/Footer";
import { CABANAS } from "@/data/cabanas";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <section id="acomodacoes" className="py-24 bg-[#faf7f2]" data-testid="acomodacoes-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-2xl mb-14">
            <p className="text-[#b85d39] text-xs uppercase tracking-[0.3em] font-bold mb-3">
              Nossos refúgios
            </p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1b4332]">
              Cabanas & Acomodações
            </h2>
            <p className="mt-4 text-[#526559] text-base leading-relaxed">
              Escolha suas datas no calendário de cada cabana, preencha seus dados e veja o
              valor total da estadia na hora. Café da manhã e jantar sempre inclusos.
            </p>
          </div>
          <div className="grid lg:grid-cols-2 gap-10">
            {CABANAS.map((cabin) => (
              <CabinCard key={cabin.id} cabin={cabin} />
            ))}
          </div>
        </div>
      </section>
      <Decoracao />
      <Faq />
      <Contato />
      <Footer />
    </div>
  );
}

export default App;
